module.exports = __webpack_public_path__ + "static/img/jiaying-padding.4a6c3be7.png";